import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { TenantService } from '../../common/services/tenant/tenant.service';
import { AUTH_ROUTES } from '../../common/constants/auth.routing.constants';

@Component({
  selector: 'lib-not-found',
  imports: [TranslocoPipe],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
  private readonly router = inject(Router);
  private readonly tenantService = inject(TenantService);

  goToLogin(): void {
    this.router.navigate([this.tenantService.authPath(AUTH_ROUTES.LOGIN)]);
  }
}
